import {
  Editor,
  EditorChangeEvent,
  ProseMirror,
  EditorUtils
} from "@progress/kendo-react-editor";
import { useRef, useState } from "react";
import { UserApi } from "../../redux/api/UserApi";
import { useReduxDispatch, useReduxSelector } from "../../redux/hooks";
import { IMentionsProps, Mentions } from "./Mentions/Mentions";
import { IMention } from "../../types/User/IMention";
import {
  IMentionsHandleOnChange,
  IMentionsHandleOnClickForTextEditor,
  MentionsHandleOnChange,
  MentionsHandleOnClickForTextEditor,
} from "./Mentions/Handlers";
import { ShowMentions } from "./Mentions/utils";
import { SetTaggedUsers } from "../../slices/TicketSlice";
import { SetHTML_Notes, SetTaggedDescription } from "../../slices/ActionSlice";
import { CommonTools, MobileTools } from "./CommonTools";
import { isMobile } from "react-device-detect";

const TextEditor = () => {
  const { EditorState, EditorView } = ProseMirror;
  const { imageResizing } = EditorUtils;
  const { data } = UserApi.useGetMentionConfigQuery();

  const [atActivated, setAtActivated] = useState(-1);
  const [mentionsText, setMentionsText] = useState("");

  const containerRef = useRef<HTMLDivElement | null>(null);

  const TaggedUsers = useReduxSelector(
    (state) => state.newTicket.TaggedUsers
  );
  const HTML_Notes = useReduxSelector(
    (state) => state.actionDetails.action.HTML_Notes
  );

  const dispatch = useReduxDispatch();
  const minChars = data ? data.Min_Chars - 1 : 0;

  function handleOnClick(person: IMention) {
    const required: IMentionsHandleOnClickForTextEditor = {
      dispatch: dispatch,
      SetDescription: SetHTML_Notes,
      SetTaggedDescription: SetTaggedDescription,
      SetTaggedUsers: SetTaggedUsers,
      TaggedUsers: TaggedUsers,
      setAtActivated: setAtActivated,
      atActivated: atActivated,
      setMentionsText: setMentionsText,
      mentionsText: mentionsText,
      HTML_Notes: HTML_Notes,
    };
    MentionsHandleOnClickForTextEditor(person, required);

  }

  function handleOnChange(e: EditorChangeEvent) {
    const eType = "EditorChangeEvent";
    const required: IMentionsHandleOnChange = {
      dispatch: dispatch,
      SetDescription: SetHTML_Notes,
      SetTaggedDescription: SetTaggedDescription,
      TaggedUsers: TaggedUsers,
      setAtActivated: setAtActivated,
      setMentionsText: setMentionsText,
      atActivated: atActivated,
      minChars: minChars.toString(),
    };
    MentionsHandleOnChange(e, eType, required);
    //dispatch(SetHTML_Notes(e.html));
  }

  const mentionsProps: IMentionsProps = {
    handleOnClick: handleOnClick,
    containerRef: containerRef,
    text: mentionsText,
  };

  const styles = `
    body {
      font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen",
      "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue",
      sans-serif;
    }
`;
  const onMount = (event) => {
    const iframeDocument = event.dom.ownerDocument;
    const style = iframeDocument.createElement("style");
    style.appendChild(iframeDocument.createTextNode(styles));
    iframeDocument.head.appendChild(style);

    //Auto focus
    console.warn('Auto focus', event);
    window.setTimeout(() => {
      event.target?.focus();
    }, 100);


    //IMage resize plugin
    const { plugins, doc } = event.viewProps.state;

    return new EditorView(
      { mount: event.dom },
      {
        ...event.viewProps,
        state: EditorState.create({
          doc,
          plugins: [...plugins, imageResizing()]
        })
      }
    );
  };



  return (
    <div ref={containerRef}>
      <Editor
        resizable={true}
        // style={{ height: "100%" }}
        contentStyle={{ height: '100%' }}
        onChange={handleOnChange}
        onMount={onMount}
        value={HTML_Notes || ''}
        tools={isMobile ? MobileTools : CommonTools}
      />
      {ShowMentions(mentionsText, minChars) && (
        <Mentions props={mentionsProps} />
      )}
    </div>
  );
};

export default TextEditor;
